import * as Yup from 'yup';

export const demoBookingSchema = Yup.object({
  fullName: Yup.string()
    .required('Full Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  phone: Yup.string()
    .matches(/^[0-9]+$/, 'Phone number must be a digit') // Basic digit validation
    .min(10, 'Phone number must be at least 10 digits')
    .required('Phone Number is required'),
  courseId: Yup.string()
    .required('Please select a course'),
  slotId: Yup.string()
    .required('Please choose an available demo time'),
  message: Yup.string()
    .max(500, 'Message cannot exceed 500 characters'),
});
